import {formatDate} from '@fullcalendar/react'
import {useState, useEffect} from 'react'
import {Spinner} from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import {useNavigate, useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import {useGetFlowsQuery} from '../../../../services/cellcast.v2'

import {
  DEFAULT_PAGINATION,
  PAGINATION_OPTIONS,
  PAGINATION_CLASSES,
} from '../../../Utils/Constant/defaultPagination'
import {Flow} from '../Flow/WorkFlow/FlowTypes'
import NodataYet from '../../../Components/NodataYet'
import {useI18n} from '../../../Utils/_helpers/useI18n'

const FlowListReport = () => {
  const {t} = useI18n()
  const navigate = useNavigate()
  const location = useLocation()

  const [page, setPage] = useState(DEFAULT_PAGINATION)
  const [reload, setReload] = useState(false)

  const {data: listFlow, isLoading, error, refetch} = useGetFlowsQuery(page)

  const flows = listFlow?.data?.items || []
  const totalPages = listFlow?.data?.totalPages || 1

  useEffect(() => {
    refetch()
  }, [location])

  if (isLoading) {
    return (
      <div className='row flex-center h-200'>
        <Spinner />
      </div>
    )
  }

  if (error) {
    toast.error(t('FLOWLIST.FETCH_ERROR'))
  }

  const navigateBack = () => {
    navigate('/automation')
  }
  return (
    <>
      <div className={`card mt-8 mb-0`}>
        <div className='card-header border-0 pt-12 px-14 d-flex align-items-center'>
          <div className='d-flex align-items-center gap-3 flex-wrap'>
            <span
              className='me-3'
              style={{cursor: 'pointer'}}
              onClick={navigateBack}
              title={t('COMMON.ACTIONS.BACK')}
            >
              <i className='bi bi-arrow-left fs-4 text-primary'></i>
            </span>

            <div className='d-flex flex-column'>
              <h3 className='card-title mb-0'>
                <span className='card-label fw-bolder fs-2 mb-1'>{t('FLOWREPORT.TITLE')}</span>
              </h3>
              <span className='text-muted mt-1 fw-bold fs-7'>{t('FLOWREPORT.SUBTITLE')}</span>
            </div>
          </div>
        </div>
        {flows.length > 0 ? (
          <div className='card-body py-3 px-14'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-400 text-muted'>
                    <th className='min-w-125px'>{t('FLOWLIST.COLUMN_NAME')}</th>
                    <th className='min-w-125px'>{t('FLOWLIST.COLUMN_CREATED')}</th>
                    <th className='min-w-150px'>{t('FLOWLIST.COLUMN_UPDATED')}</th>

                    <th className='min-w-150px text-end'>{t('FLOWLIST.COLUMN_ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {flows.map((data: Flow, idx: number) => (
                    <tr key={idx}>
                      <td>
                        <span className='text-dark  fw-bolder d-block mb-1 fs-6'>{data?.name}</span>
                      </td>
                      <td>
                        <span className='text-dark fw-400  d-block mb-1 fs-6'>
                          {formatDate(data?.createdAt)}
                        </span>
                      </td>
                      <td>
                        <span className='text-dark fw-400  d-block mb-1 fs-6'>
                          {data?.updatedAt ? formatDate(data.updatedAt) : '-'}
                        </span>
                      </td>

                      <td className='ms-2 text-end'>
                        <button
                          className='btn btn-sm btn-icon btn-light btn-active-light-primary me-2'
                          onClick={() => navigate(`/report-analytics/flow/report/${data?._id}`)}
                        >
                          <i className='bi bi-graph-up'></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <NodataYet message={t('FLOWREPORT.NO_DATA_YET')} />
        )}

        {flows.length > 0 && (
          <div className='abcd px-8 mb-2'>
            <select onChange={(e: any) => setPage({...page, limit: e.target.value, page: 1})}>
              {PAGINATION_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <ReactPaginate
              previousLabel={PAGINATION_CLASSES.PREVIOUS_LABEL}
              nextLabel={PAGINATION_CLASSES.NEXT_LABEL}
              pageCount={totalPages}
              onPageChange={(e: any) => {
                setPage({...page, page: e.selected + 1})
                setReload(true)
              }}
              containerClassName={PAGINATION_CLASSES.CONTAINER}
              previousLinkClassName={PAGINATION_CLASSES.PREVIOUS_LINK}
              nextLinkClassName={PAGINATION_CLASSES.NEXT_LINK}
              disabledClassName={PAGINATION_CLASSES.DISABLED}
              activeClassName={PAGINATION_CLASSES.ACTIVE}
            />
          </div>
        )}
      </div>
    </>
  )
}

export default FlowListReport
